import {Provider} from '@angular/core';
import {ThemePort} from '@shared/application/ports/theme/theme.port';
import {ThemeAdapter} from '@shared/infrastructure/theme/theme.adapter';

export const ThemeAdapterProvider: Provider = {
  provide: ThemePort,
  useClass: ThemeAdapter
}
